@if (['travel','travel-change'].includes(checkoutData.mode)) {
  <div class="recap-menu">
    @if (!['RETURN'].includes(checkoutData.direction)) {
      <div>
        <trenitalia-recap
          [start]="checkoutData.selectedSolution?checkoutData.selectedSolution.start.id:checkoutData.from"
          [end]="checkoutData.selectedSolution?checkoutData.selectedSolution.end.id:checkoutData.to"
          [departure]="checkoutData.selectedSolution?checkoutData.selectedSolution.departure:checkoutData.start"
          [arrive]="checkoutData.selectedSolution?checkoutData.selectedSolution.arrival:null"
          [direction]="checkoutData.direction"
          [tot]="trnService.total.value"
          [adult]="checkoutData.adult"
          [children]="checkoutData.children"
          [dataAv]="checkoutData.dataAv?checkoutData.dataAv:null"
          [trains]="checkoutData.selectedSolution?checkoutData.selectedSolution.trains:null"
          [selectedSolution]="checkoutData.selectedSolution?checkoutData.selectedSolution:null"
          [offeredServices]="checkoutData.selectedSolution?checkoutData.selectedSolution.offeredServices:null">
        </trenitalia-recap>
      </div>
    }
    @if (['RETURN'].includes(checkoutData.direction)) {
      <div class="flex-col flex-gap-8">
        <trenitalia-recap
          [start]="checkoutData.forward.selectedSolution.start.id"
          [end]="checkoutData.forward.selectedSolution.end.id"
          [departure]="checkoutData.forward.selectedSolution.departure"
          [arrive]="checkoutData.forward.selectedSolution.arrival"
          [direction]="checkoutData.direction"
          [tot]="checkoutData.forward.total"
          [adult]="checkoutData.adult"
          [children]="checkoutData.children"
          [fw]="true"
          [dataAv]="checkoutData.forward.dataAv?checkoutData.forward.dataAv:null"
          [trains]="checkoutData.forward.selectedSolution?checkoutData.forward.selectedSolution.trains:null"
          [selectedSolution]="checkoutData.forward.selectedSolution?checkoutData.forward.selectedSolution:null"
          [offeredServices]="checkoutData.forward.selectedSolution?checkoutData.forward.selectedSolution.offeredServices:null">
        </trenitalia-recap>
        <trenitalia-recap
          [start]="checkoutData.selectedSolution?checkoutData.selectedSolution.start.id:checkoutData.from"
          [end]="checkoutData.selectedSolution?checkoutData.selectedSolution.end.id:checkoutData.to"
          [departure]="checkoutData.selectedSolution?checkoutData.selectedSolution.departure:checkoutData.start"
          [arrive]="checkoutData.selectedSolution?checkoutData.selectedSolution.arrival:null"
          [direction]="checkoutData.direction"
          [tot]="checkoutData.selectedSolution?checkoutData.totalSelectedSolution:0"
          [adult]="checkoutData.adult"
          [children]="checkoutData.children"
          [dataAv]="checkoutData.dataAv?checkoutData.dataAv:null"
          [trains]="checkoutData.selectedSolution?checkoutData.selectedSolution.trains:null"
          [selectedSolution]="checkoutData.selectedSolution?checkoutData.selectedSolution:null"
          [offeredServices]="checkoutData.selectedSolution?checkoutData.selectedSolution.offeredServices:null">
        </trenitalia-recap>
        <div >
          <span class="total text-color-dark-blue" matTooltip="{{trnService.total.value['fee']>0?'Prezzo:'+(trnService.total.value['valueNet']| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia: '+(trnService.total.value['fee']| currency:'EUR':'symbol':'1.2-2'):''}}">
            Totale: {{trnService.total.value['value'] | currency:'EUR':'symbol':'1.2-2'}}
          </span>
        </div>
      </div>
    }
  </div>
}

<div class="container">
  @if (formViewerService.initialized && formViewerService.formGroup && !load) {
    <form
      [formGroup]="formViewerService.formGroup">
      @if (!checkoutData.editPassengers || ['edit','edit-traveller-pre-sale'].includes(checkoutData.mode)) {
        <div>
          <h2>Contatti acquirente</h2>
          <mat-card class="card-buyer">
            <mat-card-content>
              <div class="fx-row fx-wrap" style="gap: 3px">
                <div class="fx-flex">
                  <form-input-viewer
                    [formInputDefinition]='formFields.get("first_name")'
                    [formGroup]='formViewerService.formGroup'
                    [formControlKey]='formViewerService.controlKeyMap["first_name"]'
                    [dataContainerService]='datasetACS'
                  ></form-input-viewer>
                </div>
                <div class="fx-flex">
                  <form-input-viewer
                    [formInputDefinition]='formFields.get("last_name")'
                    [formGroup]='formViewerService.formGroup'
                    [formControlKey]='formViewerService.controlKeyMap["last_name"]'
                    [dataContainerService]='datasetACS'
                  ></form-input-viewer>
                </div>
                <div class="fx-flex"></div>
              </div>
              <div class="fx-row fx-wrap" style="gap: 3px">
                <div class="fx-flex">
                  <form-input-viewer
                    [formInputDefinition]='formFields.get("email")'
                    [formGroup]='formViewerService.formGroup'
                    [formControlKey]='formViewerService.controlKeyMap["email"]'
                    [dataContainerService]='datasetACS'
                  ></form-input-viewer>
                </div>
                <!--<div class="fx-flex">
                <form-input-viewer
                  [formInputDefinition]='formFields.get("confirm_email")'
                  [formGroup]='formViewerService.formGroup'
                  [formControlKey]='formViewerService.controlKeyMap["confirm_email"]'
                  [dataContainerService]='datasetACS'
                ></form-input-viewer>
              </div>-->
              <div class="fx-flex">
                <form-input-viewer
                  [formInputDefinition]='formFields.get("phone")'
                  [formGroup]='formViewerService.formGroup'
                  [formControlKey]='formViewerService.controlKeyMap["phone"]'
                  [dataContainerService]='datasetACS'
                ></form-input-viewer>
              </div>
              <!-- terza colonna vuota come nella riga sopra: senza questa i
              campi di questa riga sarebbero al 50% invece che a 1/3 e le
              due righe non risulterebbero allineate -->
              <div class="fx-flex"></div>
            </div>
          </mat-card-content>
          <mat-card-actions align="start">
            <mat-slide-toggle
              class="example-margin"
              color="#F39200"
              [ngModel]="checkPass"
              (toggleChange)="togglePassengerBuyer()"
              [ngModelOptions]="{standalone: true}"
              >
              L’acquirente corrisponde al passeggero 1
            </mat-slide-toggle>
          </mat-card-actions>
        </mat-card>
      </div>
    }
    <h2>Passeggeri</h2>
    @if (checkoutData.mode != 'edit-travellers') {
      <div class="alert">
        <mat-icon aria-hidden="false">warning</mat-icon>
        I biglietti sono nominativi. Lascia anche l'email e/o il telefono in caso dovessimo contattarti
      </div>
    }
    @if (!load) {
      <div>
        @for (passenger of passengers; track indexTrackBy(i, passenger); let i = $index) {
          <div>
            <trenitalia-passenger-form
              [passenger]="passenger"
              [copyContactData]="checkPass && i == 0"
              [isRoundTrip]="checkoutData?.ar"
              [canApplyDiscount]="canApplyDiscount"
              [index]="i" [contactData]="passenger1"
              (validChild)="getValid($event)"
            ></trenitalia-passenger-form>
          </div>
        }
      </div>
    }
    @if (!checkoutData.mode || ['travel','edit','edit-traveller-pre-sale'].includes(checkoutData.mode)) {
      <!-- Billing Form -->
      <div class="fx-row fx-wrap" style="gap: 3px">
        <form-input-viewer
          [formInputDefinition]='formFields.get("request_invoice")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["request_invoice"]'
        ></form-input-viewer>
      </div>
      @if (requestInvoice) {
        <trenitalia-billing-form [billingData]="checkoutData.invoiceData"></trenitalia-billing-form>
      }
    }
  </form>
}
</div>